<script setup lang="ts">
  interface IHelpContentProps {
    htmlContent: string
  }

  const props = defineProps<IHelpContentProps>()
</script>

<template>
  <div class="help max-w-[450px]" v-html="props.htmlContent"></div>
</template>

<style scoped>
  :deep(table) {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  div.help :deep(th),
  div.help :deep(td) {
    border: 1px solid var(--border);
    padding: 6px 10px;
    text-align: left;
  }

  div.help :deep(th) {
    font-weight: 600;
  }

  :deep(code) {
    background-color: var(--card-light);
    padding: 2px 4px;
    border-radius: 4px;
  }

</style>
